import React from 'react';
import { Grid, Button, Typography, Link, Divider } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import homeClasses from './homeStyles.js'
import { Link as RouterLink } from 'react-router-dom';


function Mission() {
  const globalClasses = globalUseStyles()
  const homeStyles = homeClasses()

  return (
    <ThemeProvider theme={theme}>
      <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
          <Grid className={globalClasses.containerSmall} container >
            <Grid className={homeStyles.missionAlign} item xs={12} md={5}>
                <Typography variant="subtitle1">Our Mission</Typography>
                <Typography variant="h2">Technology Done Well, Does Good.</Typography>
                <Typography variant="body1">Our mission is to help you implement innovative technology that improves the lives of the people who end up using it. </Typography>
               <Button to='/who' className={'primaryButton'} variant="outlined" color="primary" component={RouterLink}>Learn more about us</Button>
            </Grid>
            <Grid item xs={false} md={1}/>
            <Grid item xs={12} md={6} container>
                <Grid className={homeStyles.statStyle} alignItems="center" justify="center" align="center" item  sm={6} xs={12} >
                  <Typography className={globalClasses.noMargin}  variant="h3">2K</Typography>
                  <Divider className={homeStyles.dividerStat}/>
                  <Typography variant="body2">Over 2000 Caregivers Served</Typography>
                  <Typography variant="body2" >
                        <Link to='/case' className={"link link--arrowed centered"} color="primary" component={RouterLink}>View LinkedIn Profile
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                  </Typography>
                </Grid>
                <Grid className={homeStyles.statStyle} alignItems="center" justify="center" align="center" item sm={6}  xs={12} >
                  <Typography className={globalClasses.noMargin}  variant="h3">10K</Typography>
                  <Divider className={homeStyles.dividerStat}/>
                  <Typography variant="body2">Over 10K SLP and Audiology Outcomes Measures</Typography>
                  <Typography variant="body2" >
                    <Link to='/case' className={"link link--arrowed centered"} color="primary" component={RouterLink}>View LinkedIn Profile
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                  </Typography>
                </Grid>
                <Grid className={homeStyles.statStyle} alignItems="center" justify="center" align="center" item sm={6} xs={12} >
                  <Typography className={globalClasses.noMargin} variant="h3">15K</Typography>
                  <Divider className={homeStyles.dividerStat}/>
                  <Typography variant="body2">Over 15K Patient Safety Articles Hosted</Typography>
                  <Typography variant="body2" >
                    <Link to='/case' className={"link link--arrowed centered"} color="primary" component={RouterLink}>View LinkedIn Profile
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                  </Typography>
                </Grid>
                <Grid className={homeStyles.statStyle} alignItems="center" justify="center" align="center" item sm={6}  xs={12} >
                  <Typography className={globalClasses.noMargin}  variant="h3">20K</Typography>
                  <Divider className={homeStyles.dividerStat}/>
                  <Typography variant="body2">Over 20K Quality Indicators Processed</Typography>
                  <Typography variant="body2" >
                     <Link to='/case' className={"link link--arrowed centered"} color="primary" component={RouterLink}>View LinkedIn Profile
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                  </Typography>
                </Grid>
            </Grid>
          </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default Mission;